<template>
  <div v-if="visible" class="form-overlay" @click.self="handleClose">
    <div class="form-container" id="delivery-sheet-printable">
      <div class="delivery-sheet">
        <header class="header-section">
          <span></span>
          <h1>佶豐床墊 出貨單</h1>
          <span class="employee-name">{{ formData.sales_name }}</span>
        </header>
        <section class="customer-info">
          <div class="info-grid">
            <div class="info-row">
              <div class="info-item">
                <div class="info-title">訂單編號</div>
                <div class="info-field">
                  <input
                    class="order-id-input"
                    :class="{'input-error': !orderIdValid}"
                    type="text"
                    id="id"
                    v-model="orderId"
                    required
                    placeholder="請輸入訂單編號"
                  >
                </div>
              </div>
              <div class="info-item">
                <div class="info-title">訂貨日</div>
                <div class="info-field">{{ formData.order_date }}</div>
              </div>
              <div class="info-item">
                <div class="info-title">配送日</div>
                <div class="info-field">{{ formData.deliver_date }}</div>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <div class="info-title">姓名</div>
                <div class="info-field">{{ formData.name }}</div>
              </div>
              <div class="info-item">
                <div class="info-title">電話1</div>
                <div class="info-field">{{ formData.phone }}</div>
              </div>
              <div class="info-item">
                <div class="info-title">電話2</div>
                <div class="info-field">{{ formData.phone2 }}</div>
              </div>
            </div>
            <div class="info-row-half-width">
              <div class="info-item">
                <div class="info-title">地址</div>
                <div class="info-field">{{ formData.addr }}</div>
              </div>
              <div v-if="formData.addr2" class="info-item">
                <div class="info-title">地址2</div>
                <div class="info-field">{{ formData.addr2 }}</div>
              </div>
            </div>
          </div>
        </section>

        <section class="item-section">
          <div class="item-row">
            <div class="cell">尺寸</div>
            <div class="cell">品項</div>
            <div class="cell">布色</div>
            <div class="cell">數量</div>
            <div class="cell">備註、特殊尺寸</div>
          </div>
          <template v-for="item in orderItems" :key="item.id">
            <div class="item-row">
              <div class="cell">{{ item.size }}</div>
              <div class="cell">{{ item.product_name }}</div>
              <div class="cell">{{ item.color }}</div>
              <div class="cell">{{ item.quantity }}</div>
              <div class="cell">{{ item.extra_memo }}</div>
            </div>
          </template>
          <template v-for="i in emptyRowsCount" :key="`empty-${i}`">
            <div class="item-row"><div class="cell"></div><div class="cell"></div><div class="cell"></div><div class="cell"></div><div class="cell"></div></div>
          </template>
        </section>

        <section class="summary">
          <div class="summary-row">
            <div class="cell label">總金額</div>
            <div class="cell amount">{{ formatCurrency(formData.sum) }}</div>
            <div class="cell label">訂金</div>
            <div class="cell amount">{{ formatCurrency(payments.length > 0 ? payments[0].amount : 0) }}</div>
            <div class="cell label">餘額</div>
            <div class="cell amount">{{ formatCurrency(formData.sum - payments.reduce((total, payment) => total + payment.amount, 0)) }}</div>
          </div>
          <div class="summary-note-row">
            <div class="cell label">備註</div>
            <div class="cell remark">{{ (formData.memo ? formData.memo : "") +  " " + buildNote() }}</div>
            <div class="cell sign-upper">客戶簽收</div>
          </div>
          <!-- <div class="summary-sign-row">
            <div class="cell label"></div>
            <div class="cell remark">{{  }}</div>
            <div class="cell sign-lower"></div>
          </div> -->
        </section>
        <footer>
          <div class="cell warning-note">*簽收前請檢查外觀是否有破損 04-25333138</div>
        </footer>
      </div>
    </div>
    <div class="actions-container">
      <button @click="handleClose">關閉</button>
      <button @click="printPage">列印</button>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderId: '',
      orderIdValid: true,
      formData: {
        id: '',
        name: '',
        sales_id: '',
        delivered: false,
        order_date: '',
        deliver_date: '',
        phone: '',
        phone2: '',
        addr: '',
        addr2: '',
        intro_by: '',
        memo: '',
        need_invoice: false,
        invoice: '',
        share_day: false,
        sum: 0
      },
      orderItems: [],
      disposals: [],
      payments: [],
      debouncedSearch: null,
      deliverySheetHeight: 0, // Added for dynamic height check
    };
  },
  watch: {
    orderId() {
      this.debouncedSearch();
    },
    orderItems: { // Watch for changes in orderItems to re-evaluate height
      handler() {
        this.$nextTick(() => {
          this.checkDeliverySheetHeight();
        });
      },
      deep: true,
    },
  },
  created() {
    this.debouncedSearch = this.debounce(() => {
      this.loadOrderData(this.orderId);
    }, 500);
  },
  mounted() {
    this.checkDeliverySheetHeight();
  },
  methods: {
    handleClose() {
      this.orderId = '';
      this.orderIdValid = true;
      this.resetForm();
      this.$emit('close');
    },
    resetForm() {
      this.formData = {
        id: '',
        name: '',
        sales_id: '',
        delivered: false,
        order_date: '',
        deliver_date: '',
        phone: '',
        phone2: '',
        addr: '',
        addr2: '',
        intro_by: '',
        memo: '',
        need_invoice: false,
        invoice: '',
        share_day: false,
        sum: 0
      };
      this.orderItems = [];
      this.disposals = [];
      this.payments = [];
    },
    buildNote() {
      let note = '';
      if (this.payments.length > 1) {
        note += "尾款: " + this.payments.slice(1).reduce((memo, payment) => memo + payment.pay_date + " " + payment.method_name + " " + this.formatCurrency(payment.amount) + " ", "");
      }
      if (this.formData.need_invoice) {
        note += "*附發票 ";
      }
      if (this.disposals.length > 0) {
        note += "*回收x" + this.disposals.reduce((total, disposal) => total + disposal.quantity, 0);
      }
      return note;
    },
    printPage() {
      // Ensure input value is set as attribute for printing
      const orderIdInput = document.getElementById('id');
      if (orderIdInput) {
        orderIdInput.setAttribute('value', orderIdInput.value);
      }
      const printContents = document.getElementById('delivery-sheet-printable').innerHTML;
      const printWindow = window.open('_blank', '');
      printWindow.document.write('<html><head><title>Print Delivery Sheet</title>');

      // Copy all stylesheets
      Array.from(document.styleSheets).forEach(styleSheet => {
        try {
          if (styleSheet.href) {
            printWindow.document.write(`<link rel="stylesheet" href="${styleSheet.href}">`);
          } else if (styleSheet.ownerNode && styleSheet.ownerNode.tagName === 'STYLE') {
            printWindow.document.write(`<style>${styleSheet.ownerNode.innerHTML}</style>`);
          }
        } catch (e) {
          // Some stylesheets may be cross-origin and not accessible
        }
      });

      // Inject print-specific CSS from this component
      const styleTags = document.querySelectorAll('style');
      styleTags.forEach(styleTag => {
        if (styleTag.innerHTML.includes('@media print')) {
          printWindow.document.write(`<style>${styleTag.innerHTML}</style>`);
        }
      });

      printWindow.document.write('</head><body>');
      printWindow.document.write(printContents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      
      // Use setTimeout to ensure the page is fully loaded before printing
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
      };

      // Close the tab when print preview is closed
      printWindow.onafterprint = () => {
        printWindow.close();
      };
    },
    debounce(func, delay) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    },
    async loadOrderData(orderId) {
      try {
        const response = await fetch(`/api/orders/${orderId}`);
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Error response:', errorText);
          throw new Error(`Failed to fetch order data: ${response.status} ${response.statusText}`);
        }
        
        const orderData = await response.json();
        console.log('Order data loaded:', orderData);
        
        // Update form data with order details
        this.formData = orderData;
        this.orderItems = orderData.items;
        this.disposals = orderData.disposals;
        this.payments = orderData.payments;

        this.orderIdValid = true;
      } catch (error) {
        console.error('Error loading order data:', error);
        this.orderIdValid = false;
        this.resetForm();
      }
    },
    formatCurrency(val) {
      const v = val || 0;
      return new Intl.NumberFormat('zh-TW', {
        style: 'currency',
        currency: 'TWD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(v);
    },
    checkDeliverySheetHeight() {
      const printableElement = document.getElementById('delivery-sheet-printable');
      if (printableElement) {
        this.deliverySheetHeight = printableElement.offsetHeight;
      }
    },
  },
  computed: {
    emptyRowsCount() {
      const baseRows = 7;
      
      if (this.orderItems.length >= baseRows) {
        return 0; // No empty rows needed, as orderItems will dictate the total rows
      } else if (this.deliverySheetHeight > 660) {
        return baseRows - this.orderItems.length;
      } else {
        return baseRows;
      }
    }
  }
};
</script>

<style scoped>
.input-error {
  background-color: #fe8e8f !important;
  border-radius: 4px;
}

.delivery-sheet {
  width: 900px;
  padding: 20px;
  margin: 20px auto;
  border: 1px solid #000;
  background: white;
  color: #000;
  font-family: Arial, sans-serif;
}

.form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.form-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: fit-content;
  position: relative;
  margin: 20px;
  max-height: 90vh;
  overflow-y: auto;
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  margin-bottom: 0px;
}

header h1 {
  font-size: 30px;
  margin: 0 auto;
  font-weight: bold;
}

.header-section {
    display: grid;
    grid-template-columns: 1fr 5.5fr 1fr;
    align-items: center;
    text-align: center;
    margin-bottom: 0px;
}

.order-id-input {
  font-size: 18px;
  width: 140px !important;
}

.employee-name {
  font-size: 20px;
}

.customer-info {
  padding: 10px;
  font-size: 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Three columns for the first two rows */
  gap: 5px 10px; /* Row gap and column gap */
}

.info-row {
  display: contents; /* Make the div a "phantom" container for grid layout */
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.info-title {
  font-weight: bold;
  min-width: 60px; /* Adjust this value to align titles */
  text-align: left;
  margin-right: 5px;
}

.info-field {
  flex-grow: 1;
}

/* Specific grid placement for each row's elements */
.info-row:nth-child(1) .info-item:nth-child(1) { grid-column: 1 / 2; } /* Order ID */
.info-row:nth-child(1) .info-item:nth-child(2) { grid-column: 2 / 3; } /* Order Date */
.info-row:nth-child(1) .info-item:nth-child(3) { grid-column: 3 / 4; } /* Deliver Date */

.info-row:nth-child(2) .info-item:nth-child(1) { grid-column: 1 / 2; } /* Name */
.info-row:nth-child(2) .info-item:nth-child(2) { grid-column: 2 / 3; } /* Phone 1 */
.info-row:nth-child(2) .info-item:nth-child(3) { grid-column: 3 / 4; } /* Phone 2 */

.info-row-half-width {
  grid-column: 1 / -1; /* Span all columns of the parent grid */
  display: flex;
  flex-wrap: wrap; /* Allow items to wrap to the next line */
  gap: 5px 10px; /* Maintain consistent gap */
}

.info-row-half-width .info-item {
  flex: 1 1 calc(50% - 5px); /* Each item takes roughly half width, accounting for gap */
}


/* Use table is too defficult to adjust style, so use grid */
.item-section {
  border: 1px solid #000;
  border-collapse: collapse;
  margin: 0;
}

.item-row {
  display: grid;
  grid-template-columns: 1fr 1.75fr 1fr 1fr 1.75fr;
  border-bottom: 1px solid #000;
  height: 28px !important;
}

.item-row .cell {
  padding: 1px;
  display: flex;
  border-right: 1px solid #000;
  justify-content: center;
  align-items: center;
}

.item-row:last-child {
  border-bottom: none;  /* Prevent double border */
}

.item-row .cell:last-child {
  border-right: none;
}


.summary {
  border: 1px solid #000;
  border-collapse: collapse;
  margin: 0;
  border-top: none;
}

.summary-row {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr 1.5fr 1fr 1.5fr;
  border-bottom: 1px solid #000;
}

.summary-row .cell {
  align-items: center;  /* Keep content be center.*/
}

.summary-note-row  {
  display: grid;
  grid-template-columns: 1fr 4fr 2.5fr;
  height: fit-content;
  min-height: 50px;
  text-align: left;
  vertical-align: top;
}
.summary-sign-row  {
  display: grid;
  grid-template-columns: 1fr 4fr 2.5fr;
}

.summary-row:last-child {
  grid-template-columns: 1fr 4fr 2fr;
  border-bottom: none;
}

.summary .cell {
  padding: 6px;
  border-right: 1px solid black;
  display: flex;
}

.summary .cell:last-child {
  border-right: none;
}

.summary .amount {
  font-weight: bold;
  justify-content: right;
}

.summary .label {
  justify-content: center;
}

.summary .remark {
  justify-content: flex-start;
}

.summary .sign-upper {
  border-bottom: none;
}

.summary .sign-lower {
  border-top: none;
}

.summary .sign-label {
  font-weight: bold;
  justify-content: center;
}

footer {
  border: 1px solid #000;
  border-top: none;
  margin: 0;
}

footer .cell {
  padding: 8px;
  text-align: center;
}

footer .cell .warning-note {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

footer .invoice-note {
  border-right: 1px solid black;
}

.actions-container {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
}

.actions-container button {
  margin-left: 10px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
}

@media print {

  @page {
    margin: 0;
    size: auto;
  }

  body * {
    margin: 0;
    display: none !important;
  }
  
  .delivery-sheet {
    display: block !important;
    transform: scale(0.71) !important;
    transform-origin: top left !important;
    border: none;
    margin-top: 40px !important;
    margin-left: 10px !important;
    min-width: 900px;
    font-weight: bold !important;
    font-size: 22px;
  }

  html, body {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  .header-section {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    padding-bottom: 0px;
  }

  /* Apply 22px font size to all elements except h1 */
  .delivery-sheet *:not(h1) {
    font-size: 21px !important;
  }

  h1 {
    color: #000;
    font-weight: lighter;
    font-size: 26px !important;
  }

  .employee-name {
    color: #000
  }

  .customer-info {
    padding-top: 10px;
    padding-bottom: 10px;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
  }

  .info-title {
    min-width: 90px; /* Adjust this value to align titles */
  }

  .item-row {
    height: 30px !important;
  }

  .order-id-input {
    font-weight: bold;
    border: none;
  }
  
  .actions-container {
    display: none !important;
  }
}

</style>
